import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { find } from 'lodash'

import { areSameValue } from '../../core/utils'

import { apolloService } from '../../common/services'

import { INGREDIENT_EXPLANATIONS_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT_EXPLANATIONS } from '../redux/action-types'

const useIngredientsExplanationsLazyQuery = dishId => {
  const dispatch = useDispatch()

  const {
    error,
    ingredientExplanations: data,
    areIngredientExplanationsLoading: isLoading,
  } = useSelector(store =>
    find(store.dishes.dishes?.data?.result, ({ id }) =>
      areSameValue(id, dishId),
    ),
  ) || {}

  const fetch = useCallback(
    () =>
      apolloService.query({
        query: INGREDIENT_EXPLANATIONS_QUERY,
        variables: {
          id: dishId,
        },
        dispatch,
        action: FETCH_INGREDIENT_EXPLANATIONS,
      }),
    [dishId, dispatch],
  )

  return { error, data, fetch, isLoading }
}

export default useIngredientsExplanationsLazyQuery
